import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pending-invitations-header',
  templateUrl: './pending-invitations-header.component.html',
  styleUrls: ['./pending-invitations-header.component.scss'],
})
export class PendingInvitationsHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();
}
